<template>
  <v-container>

    <v-row class="mt-3 mb-3">
      <v-col lg="3" sm="6" md="3" cols="12">
        <v-card flat color="issueHigh">
          <v-card-text align="center" justify="center" class="white--text">
            <div>High</div>
            <div class="text-h3 font-weight-bold">{{ dashboardData.issues.high }}</div>
            <v-chip class="ma-2" label small color="white" outlined>{{ dashboardData.issueChange.high }}</v-chip>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="3" sm="6" md="3" cols="12">
        <v-card flat color="issueMedium">
          <v-card-text align="center" justify="center" class="white--text">
            <div>Medium</div>
            <div class="text-h3 font-weight-bold">{{ dashboardData.issues.medium }}</div>
            <v-chip class="ma-2" label small color="white" outlined>{{ dashboardData.issueChange.medium }}</v-chip>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="3" sm="6" md="3" cols="12">
        <v-card flat color="issueLow">
          <v-card-text align="center" justify="center" class="white--text">
            <div>Low</div>
            <div class="text-h3 font-weight-bold">{{ dashboardData.issues.low }}</div>
            <v-chip class="ma-2" label small color="white" outlined>{{ dashboardData.issueChange.low }}</v-chip>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="3" sm="6" md="3" cols="12">
        <v-card flat color="issueInfo">
          <v-card-text align="center" justify="center" class="white--text">
            <div>Info</div>
            <div class="text-h3 font-weight-bold">{{ dashboardData.issues.info }}</div>
            <v-chip class="ma-2" label small color="white" outlined>{{ dashboardData.issueChange.info }}</v-chip>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-data-table
      :headers="alertHeaders"
      :items="alerts"
      :items-per-page="5"
      sort-by="calories"
      class="mb-3 mt-3"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Alerts</v-toolbar-title>
        </v-toolbar>
      </template>

      <template v-slot:item.type="{ item }">
        <v-icon small :color="getIcon(item.type).color">{{getIcon(item.type).icon}}</v-icon>
      </template>

        <template v-slot:item.date="{ item }">
          {{formatDate(item.date)}}
        </template>

      <template v-slot:item.actions="">
        <v-btn icon><v-icon small @click="snackbar_visible = true"> mdi-check </v-icon></v-btn>
      </template>
    </v-data-table>

    <v-row class="mt-3">
      <v-col lg="3" sm="6" md="3" cols="12">
        <v-card flat>
          <v-card-text align="center" justify="center">
            <div>Scans Completed</div>
            <div class="text-h6 font-weight-bold">{{ dashboardData.scans.completed }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="3" sm="6" md="3" cols="12">
        <v-card flat>
          <v-card-text align="center" justify="center">
            <div>Scans In Progress</div>
            <div class="text-h6 font-weight-bold">{{ dashboardData.scans.inProgress }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="3" sm="6" md="3" cols="12">
        <v-card flat>
          <v-card-text align="center" justify="center">
            <div>Scans Scheduled</div>
            <div class="text-h6 font-weight-bold">{{ dashboardData.scans.scheduled }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="3" sm="6" md="3" cols="12">
        <v-card flat>
          <v-card-text align="center" justify="center" class="red--text">
            <div>Scans Failed</div>
            <div class="text-h6 font-weight-bold">{{ dashboardData.scans.failed }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col lg="6" sm="6" md="6" cols="12">
        <v-card flat height="100%">
          <v-card-title class="pa-6 pb-3">
            Issues by Category
          </v-card-title>
          <v-card-text>
            <div id="category-chart">
              <apexchart
                type="bar"
                height="250"
                :options="categoryOptions"
                :series="categorySeries"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col lg="6" sm="6" md="6" cols="12">
        <v-card flat height="100%">
          <v-card-title class="pa-6 pb-3">
            <p>Issues by Vector</p>
          </v-card-title>
          <v-card-text>
            <div id="vector-chart">
              <apexchart
                type="bar"
                height="250"
                :options="vectorOptions"
                :series="vectorSeries"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar color="error" v-model="snackbar_visible" :timeout="snackbar_timeout">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          plain
          snackbar_text
          v-bind="attrs"
          @click="snackbar_visible = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import { chartColorArray } from '../common/Labels';
import { DateTime } from 'luxon'
export default {
  data() {
    return {
      snackbar_visible: false,
      snackbar_text: "Demo instance - functionality disabled",
      snackbar_timeout: 2000,
      dashboardData: {
        issues: {
          high: 9,
          medium: 5,
          low: 15,
          info: 0
        },
        issueChange: {
          high: "+2",
          medium: "-2",
          low: "-",
          info: "-"
        },
        scans: {
          completed: 10,
          inProgress: 1,
          scheduled: 0,
          failed: 1
        }
      },
      alertHeaders: [
        { text: "Type", value: "type" },
        { text: "Date", value: "date" },
        {
          text: "Detail",
          align: "start",
          sortable: false,
          value: "detail",
        },
        { text: 'Acknowledge', value: 'actions', sortable: false, align: "center" },
      ],
      alerts: [
        {
          detail: "TLS detector (tls-0.1.2) failed to run for Network Single on system SecureDrop.",
          type: 2,
          date: 1643727384,
        },
        {
          detail: "All scanners and detectors unavailable (demo instance).",
          type: 1,
          date: 1643727384,
        },
      ],
      categorySeries: [
        {
          name: "High",
          data: [3, 0, 6],
        },
        {
          name: "Medium",
          data: [0, 1, 4],
        },
        {
          name: "Low",
          data: [0, 5, 10],
        },
        {
          name: "Info",
          data: [0, 0, 0],
        },
      ],
      categoryOptions: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            columnWidth: "30%",
          },
        },
        xaxis: {
          type: "string",
          categories: [
            "Explicit",
            "Correlation",
            "Discovery",
          ],
        },
        legend: {
          show: false,
          position: "right",
          offsetY: 40,
        },
        fill: {
          opacity: 1,
        },
        colors: chartColorArray,
      },
      vectorSeries: [
        {
          name: "High",
          data: [4, 3, 1, 1],
        },
        {
          name: "Medium",
          data: [1, 0, 2, 2],
        },
        {
          name: "Low",
          data: [1, 1, 11, 2],
        },
        {
          name: "Info",
          data: [0, 0, 0],
        },
      ],
      vectorOptions: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            columnWidth: "30%",
          },
        },
        xaxis: {
          type: "string",
          categories: ["Physical", "Local", "Network", "Involved"],
        },
        legend: {
          show: false,
          position: "right",
          offsetY: 40,
        },
        fill: {
          opacity: 1,
        },
        colors: chartColorArray,
      },
    };
  },
  methods: {
    getIcon(type) {
      if (type === 2) { return {icon: "mdi-alert-circle-outline", color: "red"}}
      else if (type === 1) {return {icon: "mdi-alert-outline", color: "orange"}}
      else {return {icon: "mdi-exclamation-thick", color: "blue"}}
    },
    formatDate(secs) {
      return DateTime.fromSeconds(secs).setLocale('en-GB').toLocaleString(DateTime.DATE_MED)
    }
  }
};
</script>
